import { FormularioService } from './../../../../services/formulario.service';
import { NotificationService } from './../../../../services/notification.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { CabecalhoDTO } from 'src/app/entity/dto/cabecalho.component';
import { GeneralService } from 'src/app/services/general.service';
import { ActivatedRoute } from '@angular/router';
import { EnumFormType } from 'src/app/entity/enum/enum-form-type';
import { BehaviorSubject } from 'rxjs';
import { EnumForm } from 'src/app/entity/enum/enum-form';
import { take } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { FormModalConfirmComponent } from 'src/app/shared/form-modal-confirm/form-modal-confirm.component';
import { ResumeAllFormsService } from 'src/app/services/resume-all-forms.service';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { FormPc003 } from 'src/app/entity/forms/form-pc003';
import { HumidityService } from '../../service/humidity.service';
import { TypeMessage } from 'src/app/entity/enum/enum-notification';
import { FormHumidity } from 'src/app/entity/forms/form-humidity';
import { HumidityCardIComponent } from './partialViews/humidity-card-I.component';

@Component({
  selector: 'app-form-humidity',
  templateUrl: './humidity.component.html'
})

export class FormHumidityComponent implements OnInit, AfterViewInit {

  public id: number = 0;
  public header?: CabecalhoDTO;
  public formulario?: FormGroup;
  public btnCollapse?: boolean;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public enableButtons = this.loadingSubject.asObservable();
  public showButtonSync = false;
  valuesInitial: any;
  valoresAlterados: any[] = [];
  currentUser: string = "";
  
  public formHumidity: FormHumidity = new FormHumidity();

  @ViewChild(HumidityCardIComponent, { static: false }) umidityCardIComponent: HumidityCardIComponent;

  // tslint:disable-next-line: max-line-length
  constructor(protected formBuilder: FormBuilder, 
    protected generalService: GeneralService,
    protected notificationService: NotificationService, 
    protected formularioService: FormularioService, 
    protected route: ActivatedRoute, 
    protected resumeAllFormsService: ResumeAllFormsService, 
    public dialog: MatDialog, 
    public service: HumidityService,
    private router: Router) {
    this.formulario = this.formHumidity.CreateForm(formBuilder);
  }

  ngAfterViewInit(): void {
    this.route.paramMap.subscribe( paramMap => {
      this.id = Number(paramMap.get('id'));

      if(this.id === 0){
        this.header = this.generalService.createHeader(EnumForm.FormHumidity, EnumFormType.New);
      }
      else{
        this.header = this.generalService.createHeader(EnumForm.FormHumidity, EnumFormType.Edit);
        this.service.gethumidityById(this.id).then(res =>{
          this.umidityCardIComponent.formulario.get('id').setValue(this.id);
          this.formHumidity.updateForm(res.data, this.getForms(), this.generalService);
        });
      }
    })
  }



  ngOnInit(): void {
    // tslint:disable-next-line: max-line-length
    this.header = this.generalService.createHeader(EnumForm.FormHumidity, EnumFormType.New);
    this.btnCollapse = true;
    this.loadingSubject.next(false);
  }

  async save(): Promise<void> {
    if(this.id !== 0){
      this.service.updatehumidity(this.umidityCardIComponent.formulario.getRawValue()).then((res: any) =>{
        if(res.data){
          this.notificationService.sendNotification("Registro atualizado com sucesso", TypeMessage.Edit);
          this.router.navigateByUrl('adm/humidity/list');
        }
  
      })
    }
    else{
      this.service.addhumidity(this.umidityCardIComponent.formulario.getRawValue()).then((res: any) =>{
        if(res.data){
          this.notificationService.sendNotification("Registro criado com sucesso", TypeMessage.New);
          this.router.navigateByUrl('adm/humidity/list');
        }
  
      })
    }
    
  }


  getForms(): FormGroup[] {
    const arrForms: Array<FormGroup> = new Array<FormGroup>();
    arrForms.push(this.umidityCardIComponent.formulario);
    return arrForms;
  }



  collapseAll(): void {
    this.btnCollapse = this.btnCollapse ? false : true;
    this.umidityCardIComponent.collapseCard = this.btnCollapse ? false : true;
  }

  public buildFormulario(): void {
    this.formulario = this.formHumidity.buildForm(this.formulario, this.getForms(), this.generalService);
  }
}



